import moment from 'moment'
import { Dispatch } from 'redux'

import fetchData from 'routes/Menu/fetchData'

import { AddRecipeFn } from '../domains/basket'
import { getSingleMenuApi } from '../features/singleMenuAPI/getSingleMenuApi'
import { GetState, Query } from './types'

export const ensureCurrentMenuCoversDate =
  (
    date: string,
    { query, params, addRecipe }: { query?: Query; params?: any; addRecipe: AddRecipeFn },
  ) =>
  async (dispatch: Dispatch<any>, getState: GetState) => {
    const isSingleMenuApiEnabled = await getSingleMenuApi(dispatch, getState)

    if (!isSingleMenuApiEnabled) {
      return
    }

    const currentMenuEndsAt = (getState().menuService?.data || [])[0]?.attributes?.ends_at
    const currentMenuStartsAt = (getState().menuService?.data || [])[0]?.attributes?.starts_at

    const noCurrentMenuAvailable = !currentMenuEndsAt || !currentMenuStartsAt
    const dateIsOutsideCurrentMenu =
      moment(date) > moment(currentMenuEndsAt) || moment(date) < moment(currentMenuStartsAt)

    const needsToRefetchMenu = noCurrentMenuAvailable || dateIsOutsideCurrentMenu

    if (needsToRefetchMenu) {
      dispatch(
        fetchData({ query: query || {}, params: params || {} }, true, undefined, '', {
          addRecipe,
          date,
        }),
      )
    }
  }
